// Components
const StoreCreditPreview = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "store-credit-preview" */ "@/app/views/main-view/products/components/store-credit-preview/store-credit-preview.vue"
	)
const ProductModal = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "file-upload" */ "@/app/views/main-view/products/containers/modals/product-item-modal/product-item-modal.vue"
	)

// Services
import subscriptionService from "@/app/services/main/subscription/subscription-service.js"
import productService from "@/app/services/main/product/product-service.js"
import cartService from "@/app/services/main/cart/cart-service.js"

// Constants
import { FREQUENCY_PRICE, FREQUENCY_API_CODE, PERIOD_CODE } from "@/app/constants/subscription-constants.js"
import { STATUS_CODES, SUCCESS_MSG } from "@/app/constants/status-constants"

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { shoppingMixins } from "@/app/mixins/components/shopping-mixins"
import { userMixins } from "@/app/mixins/modules/user-mixins.js"

// Third Party libraries
const VueGallerySlideshow = () =>
	import(/* webpackPrefetch: true, webpackChunkName: "vue-gallery-slideshow"*/ "vue-gallery-slideshow")
const VueLightboxAdvanced = () =>
	import(/* webpackPrefetch: true, webpackChunkName: "vue-lightbox-advanced"*/ "vue-lightbox-advanced")

export default {
	name: "ProductDetailsContainer",
	components: { StoreCreditPreview, ProductModal, VueGallerySlideshow, VueLightboxAdvanced },
	mixins: [toastMessageMixins, shoppingMixins, userMixins],
	data() {
		return {
			// Loading
			isAPILoading: false,
			isFrequencyListLoading: false,
			isPeriodListLoading: false,
			isBuyNowLoading: false,
			isAddToCartLoading: false,

			// Product
			productDetails: {},

			bundleId: null,
			bundleProducts: [
				{
					productInventory: {
						stockQty: 0,
					},
				},
			],

			someProductsOutOfStock: false,

			// Cart
			productList: [],

			// Current Dog
			ageList: {
				A: "Adult",
				P: "Puppy",
			},

			// Product Inputs
			quantity: 1,
			//-- Product Inputs Subscription
			selectedFrequencyList: "P1M",
			selectedPeriodList: "P12M",
			frequencyList: [],
			periodList: [],
			periodListDisplay: [],

			// Images
			productImages: [],
			productPrimaryImage: null,
			index: null,

			// Others
			productDoesntExist: false,
			isSubscribed: false,
			currentPage: null,

			// doggy packs
			productsQuantities: [],
		}
	},

	created() {
		if (window.location.pathname) {
			this.currentPage = window.location.pathname.substring(1)
		}
		
		this.getSubscriptionPeriod()
		this.getProductDetails()
		this.deleteCartSub()
	},

	watch: {
		'productDetails.isCustomBundle': function (newValue) {
			if (newValue) {
				this.$nextTick(() => {
					this.adjustProductListHeight();
				});
			}
		},
		selectedFrequencyList: {
			immediate: true,
			deep: true,
			handler(newValue) {
				this.periodListDisplay = [...this.periodList]
				if (newValue === FREQUENCY_API_CODE.P12M) {
					this.periodListDisplay.shift()
					if (this.selectedPeriodList) {
						if (this.selectedPeriodList.code === PERIOD_CODE.P6M) {
							this.selectedPeriodList = ""
						}
					}
				}
			},
		}
	},

	computed: {
		isDisabled() {
			let lowestAvailStock = 1;

			if(this.productDetails.products){
				const availableStocks = this.productDetails.products.map(product => {
					const availableStock = product.productInventory.stockQty;
					const productsNeeded = product.productQuantity;
	
					return Math.floor(availableStock / productsNeeded);
				})

				lowestAvailStock = Math.min(...availableStocks);
			}


			// TODO: tbc with client if we should disable the action buttons
			// if(this.productDetails.isCustomBundle && this.productDetails.subscriptionBundle){
			// 	const isStockEnough = lowestAvailStock === 0 ? false : true;
			// 	return isStockEnough && !this.selectedPeriodList;
			// }

			// if(this.productDetails.isCustomBundle){
			// 	// disable if stock is 0
			// 	return lowestAvailStock === 0 ? true: false;
			// }

			if(this.productDetails.subscriptionBundle){
				return !this.selectedPeriodList
			}
			
			return false;
		},
		isOutOfStock() {
			if (this.productDetails.subscriptionBundle && !this.productDetails.isCustomBundle) return
			return this.checkProductOutOfStock(this.productDetails)
		},
		getProductPrimaryImgIndex() {
			if (this.productImages) {
				return this.productImages.indexOf(this.productPrimaryImage[0].imageUrl)
			}
		},
		setProductPrimaryImage() {
			if (this.productDetails.isCustomBundle) {
				return this.productDetails.imageUrl
					? this.productDetails.imageUrl
					: require("@/assets/images/product/dog-default-picture-color.png")
			} else {
				if(this.productPrimaryImage && this.productPrimaryImage.length){
					return this.productPrimaryImage[0].imageUrl;
				} else{
					return require("@/assets/images/product/dog-default-picture-color.png");
				}
			}
		},
		setCheckoutButtonText() {
			return this.productDetails.subscriptionBundle ? "Subscribe Now" : "Buy Now"
		},
	},

	methods: {
		adjustProductListHeight() {
			const productDetails = this.$el.querySelector('.product-details__group-products');
			const productDescription = this.$el.querySelector('.product-details__description');
			const cardGroup = this.$el.querySelector('.cards-group');

			if (productDetails && productDescription) {
				const productDetailsHeight = productDetails.offsetHeight;
				const descriptionHeight = productDescription.offsetHeight;
				//get current max height
				const style = window.getComputedStyle(cardGroup);
				const maxHeight = style.maxHeight;
				const setMaxHeight = `${productDetailsHeight + (descriptionHeight/2)}px` // divided by 2 to not make it too long
				//set max height
				cardGroup.style.maxHeight = maxHeight < setMaxHeight ? setMaxHeight : maxHeight;
			}
		},
		// Product
		//-- Get Product Details By ID API
		async getProductDetails() {
			// Get Product ID from Query Params
			const hasQueryParams = Object.keys(this.$route.query).length > 0
			this.bundleId = this.$route.query.sku
			this.isAPILoading = true

			try {
				if (hasQueryParams) {
					const response = await productService.getBundleById(this.bundleId, this.getActivePet.id)

					// Return Product Doesnt exist with redirect button back to products
					if (response.status !== STATUS_CODES.SUCCESS) {
						this.isAPILoading = false
						this.productDoesntExist = true
						return
					}

					if (response.status === STATUS_CODES.SUCCESS) {
						this.setProductDetails(response.data)
						this.isAPILoading = false
					}
				} else {
					// Return Product Doesnt exist with redirect button back to products if no query params
					this.isAPILoading = false
					this.productDoesntExist = true
				}
			} catch (error) {
				this.isAPILoading = false
			}
		},

		//-- Set Product Details
		setProductDetails(details) {
			this.productDetails = details

			this.someProductsOutOfStock = details.products.some((item) => item.productInventory.stockQty <= 0)

			this.bundleProducts = details.products.map((products) => {
				return products
			})

			let images = this.bundleProducts.flatMap((product) => {
				return product.images
			})

			this.productImages = images.map((image) => {
				return image.imageUrl
			})

			this.productPrimaryImage = images.filter((image) => {
				return image.primary === true
			})
			
			// fallback if the API didn't return a primary image
			if ((!this.productPrimaryImage || this.productPrimaryImage.length === 0) && images.length > 0) {
				const firstImage = { ...images[0], primary: true };
				
				this.productPrimaryImage = [firstImage];
			}
			
			this.isSubscribed = details.isSubscribed
		},

		// Gallery
		onClicked(v) {
			this.index = v
		},

		replaceWithImagePlaceholder(event) {
			event.target.src = require("@/assets/images/product/dog-default-picture-color.png")
		},

		// Forms
		//-- Quantity
		numberOnlyInput(event) {
			const charCode = event.which ? event.which : event.keyCode

			if (charCode > 31 && (charCode < 48 || charCode > 57)) {
				event.preventDefault()
			} else {
				return true
			}
		},

		decreaseQuantity() {
			if(this.quantity <= 1){
				return;
			}

			this.quantity--;
			// if (this.productDetails.products[0].productInventory.stockQty && this.quantity > 1) {
			// }
		},
		increaseQuantity() {
			if(this.quantity >= 999){
				return;
			}

			this.quantity++;

			// commented the code below to remove the limitations when increasing quantity
			/*
			if (
				this.productDetails.products[0].productInventory.stockQty &&
				this.quantity < this.productDetails.products[0].productInventory.stockQty
			) {
				this.quantity++
				
				// need the most updated value of quantity
				const productsQuantities = this.productDetails.products.map(product => {
					return {
						productsNeeded: product.productQuantity * this.quantity,
						availableStock: product.productInventory.stockQty
					}
				});
	
				const areStocksEnough = productsQuantities.every(product => {
					const {productsNeeded, availableStock} = product;
					return productsNeeded <= availableStock;
				})
				

				if(!areStocksEnough){
					this.quantity--; // decrease the added quantity above
				}
			}
			*/
		},

		setQuantity() {
			this.quantity = this.quantity === "" || this.quantity === "0" ? 1 : this.quantity
			
			if (this.quantity < 1 || this.quantity >= 999) {
				this.quantity = 1
			}

			// commented the code below to remove the limitations when setting quantity
			/*
			const availableStocks = this.productDetails.products.map(product => {
				const availableStock = product.productInventory.stockQty;
				const productsNeeded = product.productQuantity;

				return Math.floor(availableStock / productsNeeded);
			});

			const lowestStock = Math.min(...availableStocks);

			if (this.quantity > lowestStock) {
				this.quantity = lowestStock;
			} else if (this.quantity < 1) {
				this.quantity = 1
			} */
			
		},

		//-- Subscription Period
		async getSubscriptionPeriod() {
			this.isAPILoading = true
			const response = await subscriptionService.getSubscriptionPeriod()
			if (response.status === STATUS_CODES.SUCCESS) {
				// Added key Monthly, Quarterly and Yearly
				this.frequencyList = response.data.paymentFrequency
				this.periodList = response.data.subscriptionPeriod
				this.periodListDisplay = [...this.periodList]
			}
			this.isAPILoading = false
		},

		//-- Subscription Frequency
		getFrequencyPrice(frequency) {
			return this.productDetails[FREQUENCY_PRICE[frequency]]
		},

		// Cart
		async addToCart(isCheckOut) {
			// check if add to cart is disabled
			if (this.isDisabled || this.isOutOfStock) return

			if (!isCheckOut) {
				this.isAddToCartLoading = true
			}

			// set cart details
			let cartDetails = {
				bundleId: this.productDetails.id,
				quantity: this.quantity,
			}

			// additional details for subscription products
			if (this.productDetails.subscriptionBundle) {
				cartDetails.subscriptionPeriodCode = this.selectedPeriodList
				cartDetails.paymentFrequencyCode = this.selectedFrequencyList
			}

			const response = await cartService.postCart(this.getActivePet.id, cartDetails)

			if (response.status === 409 && isCheckOut) {
				this.updateCartContent(cartDetails, isCheckOut)
				return
			}

			if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
				// show toast message
				const { SUCCESS_ADD_CART } = this.toastMessages.cart(this.productDetails.name)
				this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_ADD_CART, 300)
				this.setCartCount(this.getActivePet.id)

				this.redirectToCheckout(isCheckOut)
			} else {
				const { ERROR_ADD_CART } = this.toastMessages.cart(this.productDetails.name)
				this.showCustomErrorToast(ERROR_ADD_CART, "This product already exists in your cart")
			}

			this.isAddToCartLoading = false
			this.isBuyNowLoading = false
		},

		deleteCartSub() {
			cartService.getCart(this.getActivePet.id, { f_type: "products" }).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					let cartData = res.data

					cartData.forEach((item) => {
						if (item.subscriptionBundle) {
							cartService.deleteCart(this.getActivePet.id, [item.bundleId])
						}
					})
				}
			})
		},

		async updateCartContent(cartDetails, isCheckOut) {
			await cartService.putCart(this.getActivePet.id, [cartDetails])
			// if (response.status === STATUS_CODES.SUCCESS) {
			this.redirectToCheckout(isCheckOut)
			// } else {
			// 	const { ERROR_ADD_CART } = this.toastMessages.cart(this.productDetails.name)
			// 	this.showCustomErrorToast(ERROR_ADD_CART, "This product already exists in your cart.")
			// 	this.isBuyNowLoading = false
			// }
		},

		redirectToCheckout(isCheckOut) {
			let additionalParams = ""
			if (this.currentPage) {
				additionalParams = `&from=${this.currentPage}`
			}
		
			if (isCheckOut) {
				if (this.productDetails.subscriptionBundle) {
					this.$router.push("/products/checkout?bundle=" + this.productDetails.id + additionalParams)
				} else {
					this.$router.push("/products/checkout?" + additionalParams)
				}
			}
		},

		buyNow() {
			this.isBuyNowLoading = true
			if (this.isSubscribed) {
				this.$swal({
					imageHeight: "30px",
					title: "Active Subscription",
					text: "You already have an existing subscription for this product. \n Do you wish to continue?",
					imageUrl: `${require("@/assets/images/_shared/dog-confirm.png")}`,
					confirmButtonText: "Continue",
					showCancelButton: true,
					cancelButtonText: "Cancel",
					reverseButtons: true,
				}).then((result) => {
					if (result.value) {
						this.addToCart(true)
					}
					this.isBuyNowLoading = false
				})
			} else {
				this.addToCart(true)
			}
		},

		//- NOTE: Temporary fix for replacing Pet Name, API should replace the pet name before sending as response
		replacePetName(description) {
			return description.replace(new RegExp("PET_NAME", "gi"), this.getActivePet.name)
		},

		showDescriptionModal(title, description) {
			let primaryImg

			if (this.productDetails.isCustomBundle) {
				primaryImg = this.productDetails.imageUrl
					? this.productDetails.imageUrl
					: require("@/assets/images/product/dog-default-picture-color.png")
			} else {
				if(!this.productPrimaryImage && this.productPrimaryImage.length === 0){
					primaryImg = require("@/assets/images/product/dog-default-picture-color.png");
					return;
				}
				
				primaryImg = this.productImages.length
					? this.productPrimaryImage[0].imageUrl
					: require("@/assets/images/product/dog-default-picture-color.png")
			}

			this.$swal({
				imageHeight: "50px",
				imageUrl: primaryImg,
				imageAlt: "description-img",
				title: `<strong>${title}</strong>`,
				text: this.replacePetName(description),
				confirmButtonText: "Close",
			})
		},

		stocksAvailable(stockQty) {
			if (stockQty == null || stockQty <= 0) {
				return this.productDetails.isCustomBundle ? "Out of Stock" : "";
			}
			return `Available Qty: ${stockQty}`;
		}
	},
}
